export function toggleLoader(show = false, blocker = false) {
    const id = blocker ? 'global-block-loader' : 'global-loader'
    const loader = document.getElementById(id)

    if (!loader) return

    const countAtt = loader.getAttribute('counter')
    let counter = countAtt ? parseInt(countAtt) : 0

    if (show) {
        counter++
    }
    else {
        counter--
    }

    if (counter > 0) {
        if (loader?.classList.contains('hidden')) {
            loader?.classList.remove('hidden')
        }
    }
    else {
        if (!loader?.classList.contains('hidden')) {
            loader.classList.add('hidden')
        }
        if (counter < 0) {
            counter = 0
        }
    }


    loader.setAttribute('counter', counter.toString())
}